import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Link from 'next/link';
import { doc, getDoc } from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { bucketlink1 } from '../../config/fire-conf';

export default function BidsComponent(props) {
  const bsvRate = useSelector((state) => state.bsvRateReducer.bsvRate);

  const { ele, nftData } = props;

  const [isSellerMentor, setisSellerMentor] = useState(false);

  useEffect(() => {
    if (props.ele && props.ele.userId) {
      isUserMinterFunc();
    }
  }, [props.ele.userId]);

  const isUserMinterFunc = async () => {
    let dbRef = await getDoc(
      doc(firebaseFireStore, 'musicartMinters', props.ele.userId),
    );

    if (dbRef.data()) {
      setisSellerMentor(true);
    }
  };

  const nftQuan = nftData.nftQuantity ? parseInt(nftData.nftQuantity) : 1;
  const nftIndex = ele.index ? ele.index : 1;

  return (
    <div
      className={
        isSellerMentor
          ? 'asset__action asset__action--verified'
          : 'asset__action'
      }
      key={'bid' + props.index}
    >
      <img
        style={{ minWidth: 44, minHeight: 44 }}
        src={
          props?.ele?.userId &&
          bucketlink1 +
            'profile_images%2F' +
            props.ele.userId +
            '_250x250?alt=media'
        }
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = '/img/avatars/avatar.jpg';
        }}
        alt="owner image"
      />
      <p>
        {`No ${nftIndex}/${nftQuan} `}
        Bid placed for $<b>{(props.ele.bidPrice * bsvRate).toFixed(2)}</b>,{' '}
        {moment(Number(props.ele.timestamp)).fromNow(true)} ago
        <br />
        {props.ele.userName ? (
          <>
            by{' '}
            <Link prefetch={false} href={'/collector/' + props.ele.userId}>
              <a>@{props.ele.userName}</a>
            </Link>
          </>
        ) : (
          'by unknown'
        )}
      </p>
    </div>
  );
}
